import React from "react";
import logo from "../assets/images/qualiphy-logo.svg";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-300 px-10 lg:py-2 text-gray shadow-md hidden lg:block">
      <div className="w-full px-0 py-4 flex justify-between items-center">
        {/* Powered by Section */}
        <div className="flex items-center space-x-2">
          <span className="inline mb-2">Powered by</span>
          <img src={logo} alt="Qualiphy Logo" className="w-20" />
        </div>
        <div>
          <span size="small" className="inline">
            Copyright © 2024 Qualiphy, PC, Inc. All rights reserved
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
